import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { DialogNotaFiscal } from './DialogDetalheNotaFiscal';
import useSetParamsURL from '../../../../lib/useSetParamsURL';

interface NotaFiscalContextType {
    openModal: (notaFiscalId: string) => void;
    closeModal: () => void
}

const NotaFiscalContext = createContext<NotaFiscalContextType | undefined>(undefined);

export const NotaFiscalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { searchParams, clearSingleParamUrl, setParamsUrl } = useSetParamsURL();
    const codigo = searchParams.get('detalhe-nfes-entrada')
    
    const [isOpen, setIsOpen] = useState(Boolean(codigo));
    const [itemValue, setItemValue] = useState<string | null>(codigo);

    const openModal = (content: string) => {
        setItemValue(content);
        setIsOpen(true);
        setParamsUrl(content, "detalhe-nfes-entrada")
    };

    const closeModal = () => {
        setIsOpen(false);
        setItemValue(null);
        clearSingleParamUrl("detalhe-nfes-entrada")
    };


   useEffect(() => {
          if (codigo) setItemValue(codigo)
      }, [codigo])
  
    return (
        <NotaFiscalContext.Provider value={{ openModal, closeModal }}>
            {children}
            {isOpen && itemValue && (
                <DialogNotaFiscal
                    open={isOpen}
                    handleClose={closeModal}
                    notaFiscalId={itemValue}
                />
            )}
        </NotaFiscalContext.Provider>
    );
};

export const useNotaFiscal = (): NotaFiscalContextType => {
    const context = useContext(NotaFiscalContext);
    if (!context) throw new Error('useNotaFiscal must be used within a NotaFiscalProvider');
    return context;
};
